import React from 'react'

import Carousal from './Carousal'
import Footer from './Footer'
import About from './About'
import Choose from './Choose'
import Services from './Services'
import Advanced from './Advanced'
import Reviews from './Reviews'
import Map from './Map'




const Layout = () => {
  return (
    <div className='main'>

      <Carousal />
      <About />
      <br/>
      <Choose />
      <Services />
      <Advanced />
      <Reviews />
      <Map />
      <Footer />
      
    </div>
  )
}

export default Layout
